/**
 * CellDataType is used to determine what property on a {Cell} holds the value for the cell.
 *
 * This enum is a 1-to-1 map to the same-named properties in a Cell, NO_VALUE being the exception
 */
export var CellDataType;
(function (CellDataType) {
    CellDataType[CellDataType["NO_VALUE"] = 0] = "NO_VALUE";
    CellDataType[CellDataType["TEXT"] = 1] = "TEXT";
    CellDataType[CellDataType["NUMBER"] = 2] = "NUMBER";
    CellDataType[CellDataType["DATE"] = 3] = "DATE";
    CellDataType[CellDataType["DATETIME"] = 4] = "DATETIME";
    CellDataType[CellDataType["BOOLEAN"] = 5] = "BOOLEAN";
    CellDataType[CellDataType["DURATION"] = 6] = "DURATION";
    CellDataType[CellDataType["PREDECESSOR"] = 7] = "PREDECESSOR";
    CellDataType[CellDataType["CONTACT"] = 8] = "CONTACT";
    CellDataType[CellDataType["MULTICONTACT"] = 9] = "MULTICONTACT";
    CellDataType[CellDataType["MULTISELECT"] = 10] = "MULTISELECT";
    CellDataType[CellDataType["IMAGE"] = 11] = "IMAGE";
    CellDataType[CellDataType["HYPERLINK"] = 12] = "HYPERLINK";
    CellDataType[CellDataType["CONTAINERLINK"] = 13] = "CONTAINERLINK";
})(CellDataType || (CellDataType = {}));
// I'm not sure this is needed anymore
export var getCellDataTypeByKey = function (key) {
    var cellDataType = CellDataType[key];
    return cellDataType !== undefined ? cellDataType : CellDataType.NO_VALUE; // return 0 instead of undefined when key is invalid
};
//# sourceMappingURL=CellDataType.js.map